import React from 'react';

import { Text } from '../atoms';

interface OpeningDateProps {
  date: string
  color: string
}

function OpeningDate({ date, color }: OpeningDateProps) {
  return (
    <Text
      style={{
        padding: '6px 12px',
        borderRadius: '80px',
        border: `1px solid ${color}`,
      }}
      size='14px'
      weight='400'
      color='white'
    >
      {date}
    </Text>
  )
}

export default OpeningDate
